import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/logo.jpg';

const Navbar = ({ currentPage, onChangePage }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);

  const handleNavClick = (pageKey) => {
    onChangePage(pageKey);
    setOpen(false);
  };

  const isActive = (pageKey) => currentPage === pageKey;

  const navItems = [
    { key: 'inicio', label: 'Inicio' },
    { key: 'servicios', label: 'Servicios' },
    { key: 'contacto', label: 'Contacto' },
    { key: 'contacto', label: 'Pedir cotización', cta: true },
  ];

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#ffffff',
        color: '#000000',
        borderBottom: '1px solid #e5e7eb',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          maxWidth: 1200,
          width: '100%',
          mx: 'auto',
          py: { xs: 1.2, md: 2.4 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* LOGO IZQUIERDA */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img
            src={logo}
            alt="D3 Producciones Logo"
            style={{
              width:  isMobile ? 60 : 100,
              height: isMobile ? 60 : 100,
              objectFit: 'contain',
              marginBottom: isMobile ? 0 : -2,
            }}
          />
        </Box>

        {/* DESKTOP MENU */}
        {!isMobile && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 2,
            }}
          >
            <Button
              onClick={() => handleNavClick('inicio')}
              sx={{
                textTransform: 'none',
                fontWeight: isActive('inicio') ? 700 : 400,
                fontSize: 15,
                color: '#000',
                mb: -1,
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              Inicio
            </Button>

            <Box
              sx={{
                width: '2px',
                height: 32,
                backgroundColor: '#a9cf47',
                borderRadius: 1,
                mb: -1,
              }}
            />

            <Button
              onClick={() => handleNavClick('servicios')}
              sx={{
                textTransform: 'none',
                fontWeight: isActive('servicios') ? 700 : 400,
                fontSize: 15,
                color: '#000',
                mb: -1,
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              Servicios
            </Button>

            <Box
              sx={{
                width: '2px',
                height: 32,
                backgroundColor: '#a9cf47',
                borderRadius: 1,
                mb: -1,
              }}
            />

            <Button
              onClick={() => handleNavClick('contacto')}
              sx={{
                textTransform: 'none',
                fontWeight: isActive('contacto') ? 700 : 400,
                fontSize: 15,
                color: '#000',
                mb: -1,
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              Contacto
            </Button>

            {/* COTIZACIÓN */}
            <Button
              onClick={() => handleNavClick('contacto')}
              sx={{
                ml: 2,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 15,
                borderRadius: '4px',
                px: 3,
                py: 1.1,
                backgroundColor: '#3c77b6',
                color: '#fff',
                mb: -1,
                '&:hover': {
                  backgroundColor: '#335f93',
                },
              }}
            >
              Pedir cotización
            </Button>
          </Box>
        )}

        {/* MOBILE MENU BUTTON */}
        {isMobile && (
          <>
            <IconButton
              edge="end"
              onClick={() => setOpen(true)}
              sx={{ color: '#000000' }}
            >
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="right"
              open={open}
              onClose={() => setOpen(false)}
            >
              <Box
                sx={{ width: 240, py: 2 }}
                role="presentation"
              >
                <List>
                  {navItems.map((item) => (
                    <ListItem key={item.label} disablePadding>
                      <ListItemButton onClick={() => handleNavClick(item.key)}>
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            fontWeight: item.cta ? 600 : (isActive(item.key) ? 700 : 400),
                            fontFamily: 'Poppins, var(--text-font)',
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
